import { useSyncExternalStore } from "react";

/** Tiny shared store so a page can tell the top bar «you are over something dark» and the bar can tell others «I am tucked away». */
let state = { dark: false, hidden: false };
const subs = new Set();
const emit = () => subs.forEach((f) => f());
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };

export const setHeaderDark = (dark) => { if (state.dark !== dark) { state = { ...state, dark }; emit(); } };
export const setHeaderHidden = (hidden) => { if (state.hidden !== hidden) { state = { ...state, hidden }; emit(); } };
export const useHeaderState = () => useSyncExternalStore(subscribe, () => state, () => state);
